import BMView from "../../../../components/View/BMView";
import { ProductType } from "../../../../types/product";
import { MobileHomeProductProps } from "./MobileHomeProduct";
import MobileProductCard from "./MobileProductCard";

type Section = {
  productType: ProductType;
  isNew?: boolean;
};

type Props = {
  /**
   * As of now, the UI only supports until 5 sections.
   * If more sections are needed, the UI will need to be updated.
   */
  sections: Section[];
};
export default function MobileProductSection(
  props: Props & MobileHomeProductProps
) {
  const { sections, redirectProduct } = props;

  let topSection: Section[] = sections;
  let bottomSection: Section[] = [];

  switch (sections.length) {
    case 2:
    case 3:
      break;
    case 4:
    case 5:
      topSection = sections.slice(0, 2);
      bottomSection = sections.slice(2, 5);
      break;
    default:
      return null;
  }

  if (bottomSection.length === 0) {
    return (
      <BMView flex row spacing="md">
        {topSection.map(({ productType, isNew }, index, arr) => (
          <MobileProductCard
            key={index}
            productType={productType}
            isNew={isNew}
            type={arr.length > 2 ? "COMPACT" : "NORMAL"}
            redirectProduct={redirectProduct}
            disabled={props.disabled}
          />
        ))}
      </BMView>
    );
  }

  return (
    <BMView flex spacing="md">
      <BMView flex row spacing="md">
        {topSection.map(({ productType, isNew }, index, arr) => (
          <MobileProductCard
            key={index}
            productType={productType}
            isNew={isNew}
            type={arr.length > 2 ? "COMPACT" : "NORMAL"}
            redirectProduct={redirectProduct}
            disabled={props.disabled}
          />
        ))}
      </BMView>
      <BMView flex row spacing="md">
        {bottomSection.map(({ productType, isNew }, index, arr) => (
          <MobileProductCard
            key={index}
            productType={productType}
            isNew={isNew}
            type={arr.length > 2 ? "COMPACT" : "NORMAL"}
            redirectProduct={redirectProduct}
            disabled={props.disabled}
          />
        ))}
      </BMView>
    </BMView>
  );
}
